import type { SVGProps } from 'react';

const SvgChannelAffinity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="channel-affinity"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#232121"
      d="M26.61 14.77c-.37 0-.72-.22-.87-.56l-1-2.13a.508.508 0 0 0-.24-.24l-2.14-1c-.33-.15-.55-.5-.55-.87s.22-.72.56-.87l2.13-.99c.11-.05.19-.14.24-.24l1-2.14a.959.959 0 0 1 1.74.01l1 2.13c.05.11.14.19.24.24l2.14 1c.33.15.55.5.55.87s-.22.72-.56.87l-2.13 1c-.11.05-.19.14-.24.24l-1 2.14c-.16.34-.5.55-.87.55Zm-.49-1.19Zm.98-.01Zm-3.06-3.6 1.09.51c.43.2.77.54.97.97l.51 1.09.51-1.09c.2-.43.54-.77.97-.97l1.09-.51-1.09-.51c-.43-.2-.77-.54-.97-.97l-.51-1.09-.51 1.09c-.2.43-.54.77-.97.97l-1.09.51Zm6.18.48Zm-7.21 0Zm7.21-.97Zm-7.22 0Zm3.12-3.13Zm.98 0Z"
    />
    <path
      fill="#232121"
      d="M30.68 30.06V18.74c0-1.52-1.23-2.75-2.75-2.75h-2.64c-1.52 0-2.75 1.23-2.75 2.75v11.32h-2.47V3.7c0-1.52-1.23-2.75-2.75-2.75h-2.64c-1.52 0-2.75 1.23-2.75 2.75v26.35H8.98V12.78c0-1.52-1.23-2.75-2.75-2.75H3.59c-1.52 0-2.75 1.23-2.75 2.75v18.78h30.3v-1.5h-.47Zm-6.64-11.32c0-.69.56-1.25 1.25-1.25h2.64c.69 0 1.25.56 1.25 1.25v11.32h-5.14V18.74ZM13.44 3.7c0-.69.56-1.25 1.25-1.25h2.64c.69 0 1.25.56 1.25 1.25v26.35h-5.14V3.7ZM2.35 12.78c0-.69.56-1.25 1.25-1.25h2.64c.69 0 1.25.56 1.25 1.25v17.28H2.35V12.78Z"
    />
  </svg>
);

export default SvgChannelAffinity;
